// extracted by mini-css-extract-plugin
export default {"narrow":"narrow--29tVn"};